module.exports = __webpack_public_path__ + "img/Oluseyi Onigbinde_Data Analyst.8042b75a.jpg";